import script from "./UniversalScheduler.vue?vue&type=script&setup=true&lang=ts"
export * from "./UniversalScheduler.vue?vue&type=script&setup=true&lang=ts"

import "./UniversalScheduler.vue?vue&type=style&index=0&id=45df7773&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45df7773"]])

export default __exports__